import { StepWrapper } from '../../../styles';
import { TranslatedTitle } from '../components';
import { BranchSelect, DegreeSelect, UniversitySelect } from '../components';

import { Box } from '@/components/Utils';

export const DefineYourGoal = () => {
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="DEFINE_YOUR_GOAL" />
      <Box flexDirection="column">
        <BranchSelect />
        <DegreeSelect />
        <UniversitySelect />
      </Box>
    </StepWrapper>
  );
};
